// extracted by mini-css-extract-plugin
export default {"container":"Components_container__25mMY","grid":"Components_grid__y8qLt"};